export default function() {
    const rrRegStartWrapper = document.querySelector('#divRRRegStart');

    if (!rrRegStartWrapper) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {

            const tile = document.querySelector('.js-tile-registration');
            const startButtonsSelector = 'RRRegStartButtons';
            const startButtonsSelectorDefault = 'RRRegStart_Registrations';
            const rrRegStartButtons = document.querySelector(`#${startButtonsSelector}`) || document.querySelector(`.${startButtonsSelectorDefault}`);

            if (!tile) return;

            if (
                rrRegStartButtons
                && mutation.type === 'childList'
                && mutation.addedNodes[0] === rrRegStartButtons
            ) {
                tile.classList.add('is-visible');
            }

            if (mutation.removedNodes.length > 0) {
                if (mutation.removedNodes[0].id === startButtonsSelector || mutation.removedNodes[0].id === startButtonsSelectorDefault ) {
                    tile.classList.remove('is-visible');
                    observer.disconnect();
                }
            }
        });
    });

    observer.observe(rrRegStartWrapper, {childList: true});
}
